import { useNavigate } from "react-router-dom";
import { PropsView } from "../Models/faq";
import { faqInfos } from "../constants/faqInfos";

export default function useFaqPage(): PropsView {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const goToContact = () => navigate("/faq/contact");

  return {
    goBack,
    goToContact,
    infos: faqInfos,
  };
}
